export const getComponentOption = function (routerItem) {
    return routerItem || {};
};
